import { Box, Typography } from "@mui/material";

interface SimpleCardPropsType {
  title: string;
  value: string;
  color?: string;
}

const SimpleCard = ({ title, value, color }: SimpleCardPropsType) => {
  return (
    <Box
      sx={{
        height: "80px",
        borderRadius: "10px",
        border: "0.5px solid #DFDFDF",
        px: "16px",
        boxShadow: "0px 0px 4px 0px #00000026",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        flex: 1,
      }}
    >
      <Typography
        sx={{
          fontSize: "13px",
          lineHeight: "24px",
          letterSpacing: -0.02,
          color: "#A5A5A5",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>
      <Box sx={{ textAlign: "right" }}>
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: "21px",
            lineHeight: "34px",
            letterSpacing: -0.02,
            color: color ? "#357AFF" : "#242424",
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default SimpleCard;
